// Planning calendar dates and backend timestamps must render identically on
// the server and in browsers outside the server's timezone.
export function parsePlanningDate(value) {
  if (!value) return null;
  let normalized = value;
  if (typeof value === 'string') {
    normalized = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
      normalized += 'T00:00:00Z';
    } else if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(normalized)) {
      normalized = normalized.replace(' ', 'T') + 'Z';
    }
  }
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatLongPlanningDate(value) {
  const date = parsePlanningDate(value);
  if (!date) return null;
  return date.toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/London',
  });
}
